// Export all services for easy importing
export { default as api } from './api';
export { default as authService } from './authService';
export { default as cartService } from './cartService';
export { default as orderService } from './orderService';
export { default as paymentService } from './paymentService';
export { default as productService } from './productService';
export { default as reviewService } from './reviewService';
export { default as wishlistService } from './wishlistService';
export { default as dropboxService } from './dropboxService';

// Environment configuration validation
export const validateEnvironment = () => {
  const required = [
    'VITE_NOCODEBACKEND_KEY',
    'VITE_NOCODEBACKEND_INSTANCE'
  ];
  
  const optional = [
    'VITE_NOCODEBACKEND_URL',
    'VITE_DROPBOX_ACCESS_TOKEN',
    'VITE_DROPBOX_APP_KEY',
    'VITE_DROPBOX_APP_SECRET'
  ];

  const missing = required.filter(key => !import.meta.env[key]);
  const missingOptional = optional.filter(key => !import.meta.env[key]);

  if (missing.length > 0) {
    console.error('Missing required environment variables:', missing);
    return false;
  }

  if (missingOptional.length > 0) {
    console.warn('Missing optional environment variables:', missingOptional);
  }

  console.log('Environment configuration validated successfully');
  return true;
};

// Initialize environment validation
validateEnvironment();